<template>
  <div class="legal-page">
    <header class="legal-page__bar">
      <b-link
        :to="{ name: 'auth-login' }"
        class="legal-page__brand"
      >
        <b-img
          :src="appLogoImage"
          alt=""
          class="legal-page__logo"
        />
        <span>YoConstruyo</span>
      </b-link>
      <nav class="legal-page__nav">
        <b-link
          :to="{ name: 'legal-terms' }"
          :class="{ 'legal-page__tab--active': kind === 'terms' }"
        >
          Términos
        </b-link>
        <b-link
          :to="{ name: 'legal-privacy' }"
          :class="{ 'legal-page__tab--active': kind === 'privacy' }"
        >
          Privacidad
        </b-link>
      </nav>
    </header>

    <main class="legal-page__sheet">
      <div
        v-if="loading"
        class="legal-page__state"
      >
        <b-spinner small />
        Cargando el documento...
      </div>

      <template v-else-if="document">
        <p class="legal-page__eyebrow">
          Versión {{ document.version }} · Vigente desde {{ formatDate(document.published_at) }}
        </p>
        <h1 class="legal-page__title">
          {{ document.title }}
        </h1>
        <legal-text :body="document.body" />
      </template>

      <div
        v-else
        class="legal-page__state"
      >
        Este documento todavía no está publicado.
      </div>
    </main>
  </div>
</template>

<script>
import { BLink, BImg, BSpinner } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import LegalText from '@/components/legal/LegalText.vue'

export default {
  components: {
    BLink,
    BImg,
    BSpinner,
    LegalText,
  },

  data() {
    return {
      loading: true,
      appLogoImage: $themeConfig.app.appLogoImage,
    }
  },

  computed: {
    kind() {
      return this.$route.meta.legalKind
    },
    document() {
      return this.$store.getters['legal/currentDocument'](this.kind)
    },
  },

  watch: {
    kind() {
      window.scrollTo(0, 0)
    },
  },

  created() {
    this.$store.dispatch('legal/fetchCurrentLegal')
      .catch(() => {})
      .finally(() => { this.loading = false })
  },

  methods: {
    formatDate(value) {
      if (!value) return ''
      return new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(value))
    },
  },
}
</script>

<style lang="scss" scoped>
$ink: #0f172a;
$muted: #64748b;
$line: #e2e8f0;
$green: #16a34a;

.legal-page {
  min-height: 100vh;
  background: #eef1f5;
  padding: 0 1rem 3rem;
}

.legal-page__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  max-width: 820px;
  margin: 0 auto;
  padding: 1.25rem 0;
}

.legal-page__brand {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: $ink;
}

.legal-page__logo {
  height: 30px;
  width: auto;
}

.legal-page__nav {
  display: flex;
  gap: 0.25rem;

  a {
    padding: 0.35rem 0.85rem;
    border-radius: 999px;
    font-size: 0.9rem;
    font-weight: 600;
    color: $muted;
  }

  .legal-page__tab--active {
    background: #fff;
    color: $ink;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  }
}

.legal-page__sheet {
  max-width: 820px;
  margin: 0 auto;
  padding: 2.5rem clamp(1.25rem, 5vw, 3.5rem);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.06);
}

.legal-page__eyebrow {
  margin: 0 0 0.4rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: $green;
}

.legal-page__title {
  margin: 0 0 1.75rem;
  font-size: clamp(1.6rem, 4vw, 2.1rem);
  font-weight: 700;
  line-height: 1.15;
  color: $ink;
}

.legal-page__state {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 2rem 0;
  color: $muted;
}
</style>
